import { BuildClass } from '../../../universal';
import { React, _ } from '../../lib';
import { PromptConfirm } from '../index';
import { ListGrid, } from './list-grid';
import { useRSInstance, useStateSync } from './meta-types';
import { ResizeSplitter } from './resize-split';
import { stubListGrid } from './stubs';
import { ToolbarNew } from './toolbar';
const getDefaultState = (props) => ({
    selectedItem: props.value ?? (props.multiple ? [] : null),
    searchText: props.view?.searchText ?? '',
    showInactive: props.view?.showInactive ?? false,
    splitWidths: props.view?.splitWidths ?? null,
    listGridView: props.view?.listGridView ?? {},
    isAskingToChange: false,
});
export const SidebarListGrid = (props) => {
    const rs = useRSInstance({
        props: props,
        defaultState: getDefaultState,
        refs: {
            listGrid: React.useRef(stubListGrid),
        },
        actionToDelta: getPartialStateFromAction,
    });
    useStateSync({
        propVal: props.value,
        stateVal: rs.state.selectedItem,
        setState: v => {
            rs.dispatch([
                Action.UpdateValue,
                {
                    value: v,
                },
            ]);
        },
        setProp: v => {
            rs.props.onUpdateValue?.(v);
        },
    });
    const hasSelectedSomething = rs.props.multiple
        ? _.size(rs.state.selectedItem) > 0
        : Boolean(rs.state.selectedItem);
    const useFormWidth = rs.props.formWidth != null;
    const formContent = (React.createElement(React.Fragment, null, hasSelectedSomething ? (rs.props.buildForm(rs.state.selectedItem)) : (React.createElement("div", { className: BuildClass(rs.props.stubMessage?.className ??
            'w-full h-full pt-5 bg-neutral-200 text-center font-light text-xl text-neutral-500') }, rs.props.stubMessage?.lbl ?? 'Nothing Selected'))));
    return (React.createElement("div", { className: "tailwind-wrapper", style: { height: '100%' } },
        React.createElement(ResizeSplitter, { className: rs.props.className?.resizeSplitter, value: rs.state.splitWidths, onUpdate: v => {
                rs.dispatch([Action.UpdateView, { splitWidths: v }]);
            }, panes: [
                useFormWidth
                    ? {
                        minWidth: null,
                        maxWidth: null,
                        defaultWidth: null,
                        collapsible: false,
                        flexWidth: 1,
                        content: React.createElement(SidebarListGridSidebar, { rs: rs }),
                    }
                    : {
                        minWidth: rs.props.sidebarWidth?.minWidth ?? 160,
                        maxWidth: rs.props.sidebarWidth?.maxWidth ?? null,
                        defaultWidth: rs.props.sidebarWidth?.defaultWidth ?? 240,
                        collapsible: rs.props.sidebarWidth?.collapsible ?? true,
                        flexWidth: null,
                        content: React.createElement(SidebarListGridSidebar, { rs: rs }),
                    },
                useFormWidth
                    ? {
                        defaultWidth: rs.props.formWidth?.defaultWidth ?? 400,
                        minWidth: rs.props.formWidth?.minWidth ?? 320,
                        maxWidth: rs.props.formWidth?.maxWidth ?? null,
                        flexWidth: null,
                        collapsible: rs.props.formWidth?.collapsible ?? false,
                        content: formContent,
                    }
                    : {
                        defaultWidth: null,
                        minWidth: null,
                        maxWidth: null,
                        flexWidth: 1,
                        collapsible: false,
                        content: formContent,
                    },
            ] })));
};
export const SidebarListGridSidebar = (props) => {
    const rs = props.rs;
    const hasUnsavedChanges = rs.props.unsavedChanges?.isUnsaved?.();
    return (React.createElement(React.Fragment, null,
        React.createElement(ToolbarNew, { className: rs.props.className?.toolbar, lhs: [
                {
                    type: 'searchbox',
                    width: rs.props.searchBox?.width ?? 72,
                    placeholder: rs.props.searchBox?.placeholder ?? 'Search...',
                    visible: !Boolean(rs.props.searchBox?.disable ?? false),
                    value: rs.state.searchText,
                    onUpdate: v => {
                        rs.dispatch([Action.UpdateView, { searchText: v }]);
                    },
                    onArrowDelta: (delta, shiftKey) => {
                        rs.refs.listGrid.current
                            ?.getList()
                            ?.moveSelection(delta, shiftKey);
                    },
                },
                {
                    type: 'checkbox',
                    lbl: rs.props.inactivity?.lbl?.text ?? 'Inactive',
                    visible: Boolean(rs.props.inactivity),
                    width: rs.props.inactivity?.lbl?.width ?? 76,
                    value: rs.state.showInactive,
                    onUpdate: v => {
                        rs.dispatch([Action.UpdateView, { showInactive: v }]);
                    },
                },
                ...(rs.props.toolbarExtra?.lhs ?? []),
            ], rhs: [
                ...(rs.props.toolbarExtra?.rhs ?? []),
                {
                    type: 'button-add',
                    visible: Boolean(rs.props.adding),
                    width: rs.props.adding?.lbl?.width ?? 74,
                    lbl: rs.props.adding?.lbl?.text ?? 'Add',
                    onClick: () => {
                        confirmUnsavedChanges(rs, () => {
                            rs.props.adding?.onClick?.();
                        });
                    },
                },
            ] }),
        React.createElement(ListGrid, { ref: rs.refs.listGrid, className: BuildClass([
                '!h-[calc(100%-40px)]',
                rs.props.className?.listGrid,
            ]), value: rs.state.selectedItem, onUpdate: v => {
                rs.dispatch([
                    Action.UpdateValue,
                    { value: v },
                ]);
            }, view: rs.state.listGridView, onUpdateView: v => {
                rs.dispatch([Action.UpdateView, { listGridView: v }]);
            }, data: _.filter(rs.props.data, x => {
                if (!rs.props.inactivity || rs.state.showInactive) {
                    return true;
                }
                return !rs.props.inactivity.isInactive(x);
            }), multiple: rs.props.multiple, pk: rs.props.pk, fields: rs.props.fields, searchText: rs.state.searchText, classRow: x => {
                const isInactive = Boolean(x && rs.props.inactivity?.isInactive(x));
                const otherClasses = rs.props.listGridSettings?.classRow?.(x) ?? '';
                const inactive = rs.props.inactivity?.className ?? 'text-neutral-500';
                return BuildClass({
                    [BuildClass(otherClasses)]: true,
                    [BuildClass(inactive)]: isInactive,
                });
            }, readOnly: rs.props.listGridSettings?.readOnly ||
                (hasUnsavedChanges && !rs.state.isAskingToChange), onClick: hasUnsavedChanges
                ? (x, e) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    confirmUnsavedChanges(rs, () => {
                        const value = [String(rs.props.pk(x))];
                        const lg = rs.refs.listGrid.current;
                        lg?.getList()?.setSelected(value);
                        lg?.focus();
                    });
                }
                : undefined, ..._.omit(rs.props.listGridSettings, ['classRow', 'readOnly']) })));
};
const confirmUnsavedChanges = (rs, yes) => {
    if (!rs.props.unsavedChanges?.isUnsaved?.()) {
        yes();
        return;
    }
    rs.updateState({ isAskingToChange: true });
    PromptConfirm({
        size: rs.props.unsavedChanges?.warning?.size ?? [360, 200],
        msg: rs.props.unsavedChanges?.warning?.message ??
            'You have unsaved changes. Are you sure you want to do this?',
        no: () => {
            rs.updateState({ isAskingToChange: false });
        },
        yes: done => {
            rs.updateState({ isAskingToChange: false });
            yes();
            done(true);
        },
    });
};
var Action;
(function (Action) {
    Action[Action["UpdateValue"] = 0] = "UpdateValue";
    Action[Action["UpdateView"] = 1] = "UpdateView";
})(Action || (Action = {}));
const getPartialStateFromAction = (rs, p) => {
    switch (p[0]) {
        case Action.UpdateValue:
            const value = p[1].value;
            rs.props.onUpdateValue?.(value);
            return { selectedItem: value };
        case Action.UpdateView:
            rs.props.onUpdateView?.({
                ..._.omit(rs.state, 'selectedItem'),
                ...p[1],
            });
            return p[1];
    }
};
//# sourceMappingURL=sidebar-listgrid.js.map